import { render, staticRenderFns } from "./registerEntry_tl6.vue?vue&type=template&id=20bf4425&scoped=true"
import script from "./registerEntry_tl6.vue?vue&type=script&lang=js"
export * from "./registerEntry_tl6.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/registerEntry_tl6.scss?vue&type=style&index=0&id=20bf4425&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf4425",
  null
  
)

export default component.exports